 async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_drawer").innerHTML;
  document.querySelector(".u_cart_drawer").innerHTML = newBox;
}

 function getCartCount() {
    $.getJSON('/cart.js', function(cart){ 
      var result = cart.item_count;
      console.log(result);     
        $('.cart-count-bubble span').text(result);
      });
    }
    $(document).ready(function(){
      getCartCount();
    });
$(function(){
  c_slider()

  function c_slider(){
const swiper = new Swiper('.u_uppsels_block_row_outer', {
     slidesPerView: "auto",
  spaceBetween: 10,
  grabCursor: true,
  navigation: {
    nextEl: '.u_swiper_right_arrow',
    prevEl: '.u_swiper_left_arrow',
  },
    breakpoints: {
    990: {
      slidesPerView: "auto",
      spaceBetween: 10,
      }
    }
});
  }
  
   $(document).on('click','cart-remove-button button,.quantity__button',function(){
console.log('efef')
 setTimeout(function(){
        c_slider()                  
      }, 4000);
   })
     $(document).on('click','.product-form__submit,.card__link button',function(){
console.log('efef')
 setTimeout(function(){
        c_slider()                  
      }, 5000);
   })
 $(document).on('click','.u_uppsell_pro_btn',function(){
     let variant_id = $(this).attr('var-id').trim()
     $.ajax({
        type:'POST',
        url:'/cart/add.js',
         data : {
        "id": variant_id,
        "quantity": 1,        
      },
 dataType: 'json',
        success: function(result){
        console.log('add to cart');
console.log("add to cart");
updateCartDrawer()
         setTimeout(function(){
        getCartCount(); 
        c_slider()                  
      }, 1000);
      },
             error: function(err) {
               console.log('error',err)
      },
         complete: function() {
                      console.log('complete');
      }
    })
    })
    })
    